import { useEffect } from 'react';

export const useOutsiderDetector = (ref: any, callBack: () => void) => {
	useEffect(() => {
		const handleClickOutside = (e: { target: any }) => {
			if (!!callBack && ref.current && !ref.current.contains(e.target)) {
				callBack();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [callBack, ref]);
};
